import { render, staticRenderFns } from "./ColaboradoresPontosAdminPage.vue?vue&type=template&id=f8bf34ca&scoped=true"
import script from "./ColaboradoresPontosAdminPage.vue?vue&type=script&lang=js"
export * from "./ColaboradoresPontosAdminPage.vue?vue&type=script&lang=js"
import style0 from "./ColaboradoresPontosAdminPage.vue?vue&type=style&index=0&id=f8bf34ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bf34ca",
  null
  
)

export default component.exports